// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xI5P","tabsBox":"styles_tabsBox__2ru44","createButton":"styles_createButton__2z_y7"};